import { useState, type FormEvent } from 'react'
import { Panel, Button, Field } from '../ds/index'
import { PasswordField } from '../components/PasswordField'
import { post, ApiError } from '../lib/api'
import { useSession } from '../lib/session'
import { HandpickedTree } from '../components/BrandMark'

export default function Login() {
  const { refresh, config } = useSession()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  const [forgot, setForgot] = useState(false)
  const [forgotMsg, setForgotMsg] = useState<string | null>(null)

  const askReset = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    try { setForgotMsg((await post<{ message: string }>('/api/auth/forgot', { email })).message) } catch { setForgotMsg('Could not reach the server') } finally { setBusy(false) }
  }

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await post('/api/auth/login', { email, password })
      await refresh()
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not reach the server')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="login">
      <Panel className="login-card">
        {config?.brand === 'handpicked' ? (
          <div className="hp-login-mark">
            <HandpickedTree size={112} />
            <span className="hp-wordmark">Handpicked</span>
            <span className="hp-tagline">Premium leads. Real results.</span>
          </div>
        ) : <div className="login-mark">Leads</div>}
        <p className="login-sub">{config?.brand === 'handpicked' ? 'Sign in to see your leads, what they cost, and your account.' : 'Requests from your groups, routed to the rep who can help. Sign in to continue.'}</p>
        {forgot ? (
          <form onSubmit={askReset} className="stack">
            <Field label="Email" type="email" autoFocus autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
            {forgotMsg ? <p className="form-help" role="status" style={{ margin: 0 }}>{forgotMsg}</p>
              : <Button type="submit" disabled={busy || !email}>{busy ? 'Sending' : 'Email me a reset link'}</Button>}
            <button type="button" className="link-button" onClick={() => { setForgot(false); setForgotMsg(null) }}>Back to sign in</button>
          </form>
        ) : (
          <form onSubmit={submit} className="stack">
            <Field label="Email" type="email" autoFocus autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
            <PasswordField label="Password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
            {error && <p className="form-error" role="alert">{error}</p>}
            <Button type="submit" disabled={busy || !email || !password}>{busy ? 'Signing in' : 'Sign in'}</Button>
            <button type="button" className="link-button" onClick={() => setForgot(true)}>Forgot your password?</button>
          </form>
        )}
        {config?.demoData && <p className="muted" style={{ fontSize: 'var(--t-ui)', marginTop: 'var(--s-6)' }}>Demo install. Every record is invented.</p>}
        <div className="powered">Powered by SPEC Systems</div>
      </Panel>
    </div>
  )
}
